import { render, staticRenderFns } from "./Allfeedback.vue?vue&type=template&id=eb41a9a8&scoped=true&"
import script from "./Allfeedback.vue?vue&type=script&lang=js&"
export * from "./Allfeedback.vue?vue&type=script&lang=js&"
import style0 from "./Allfeedback.vue?vue&type=style&index=0&id=eb41a9a8&prod&lang=scss&"
import style1 from "./Allfeedback.vue?vue&type=style&index=1&id=eb41a9a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb41a9a8",
  null
  
)

export default component.exports